import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import { DateRangePickerText, DefaultText, TicketsFiltersInputText } from '../common/fontElements';

export const AdminTools = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  background-color: ${colors.baseBackground};
  width: 100%;
`;

AdminTools.displayName = 'AdminTools';

export const SwitchFiltersButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  cursor: pointer;
`;

export const SwitchFiltersImage = styled.img`
  width: 8px;
  height: 4px;
  align-self: center;
  margin-left: 4px;
`;

export const Divider = styled.div`
  position: relative;
  min-height: 25px;
  border-bottom: 1px solid ${colors.lightGray21};
`;

export const DateRangeFilter = styled.div`
  width: 100%;
  height: 100%;
`;

export const DateRangePickerWrapper = styled.div`
  display: flex;
  z-index: 300;
  height: 25px;
  background-color: ${colors.baseBackground};
  border: 1px solid ${colors.lightGray21};
  border-radius: 4px;
  width: 100%;

  .DayPicker {
    z-index: 400;
  }
  .DateRangePickerInput {
    padding-left: 5px;
  }
`;

export const DateRangePickerComponent = styled(DateRangePickerText)`
  .DateRangePicker {
    height: 23px;
    flex: 1 1;

    .DateRangePickerInput {
      height: 23px;
      background-color: ${colors.baseBackground};
      border: 0;
      border-radius: 4px;
      overflow: hidden;
      width: 100%;

      .DateInput {
        background-color: ${colors.baseBackground};
        max-width: 45%;

        .DateInput_input {
          background-color: ${colors.baseBackground};
          color: ${colors.formInputTextForFilledBack};
        }
      }

      .DateRangePickerInput_arrow {
        height: 20px;

        .DateRangePickerInput_arrow_svg {
          height: 100%;
          background-color: ${colors.baseBackground};
        }
      }
    }

    .DateRangePicker_picker__openDown {
      box-shadow: 0 0 5px 1px ${colors.lightGray21};
      top: 25px;

      .DayPickerNavigation_container {
        height: 42px;

        .DayPickerNavigation_svg__vertical {
          height: 20px;
          width: 20px;
        }
      }
    }
  }
`;

export const FilterHolder = styled.div`
  width: ${(props) => (props.width ? props.width : 'auto')};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: baseline;
  padding-right: 15px;
  margin-bottom: 5px;

  &:last-child {
    padding-right: 0;
  }
`;

export const FilterLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.45;
  color: ${colors.blue1};
`;

export const FiltersGroup = styled(DateRangePickerComponent)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 5px;
  max-width: 700px;

  &:last-child {
    max-width: 100%;
  }
`;

export const CheckboxHolder = styled.div`
  padding-right: 5px;
  min-width: 120px;
  display: flex;
  align-items: center;
`;

export const Checkbox = styled.input`
  margin: 0 5px 0 0 !important;
`;
FilterHolder.displayName = 'FilterHolder';

export const Inbox = styled.div`
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;
Inbox.displayName = 'Inbox';

export const SimplrTicketNumberBox = styled.div`
  width: 100%;
`;

export const SimplrTicketNumberField = styled(TicketsFiltersInputText)`
  height: 25px;
  width: 100%;
  background-color: ${colors.baseBackground};
  color: ${colors.formInputTextForFilledBack};
  border: 1px solid ${colors.lightGray21};
  border-radius: 4px;
  padding: 0 7px;

  &:focus {
    outline: none;
  }
`;

export const PaginationControls = styled.div`
  flex: 0 0 125px;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  align-self: flex-end;
  min-width: 125px;
  align-items: center;
  margin-bottom: 5px;
  height: 25px;
`;
PaginationControls.displayName = 'PaginationControls';

export const PaginationLabel = styled(DefaultText)`
  padding: 0 5px;
`;
PaginationLabel.displayName = 'PaginationLabel';

export const PaginationButton = styled.span`
  cursor: pointer;
  top: -2px !important;

  &:before {
    color: ${colors.lightGray21};
    font-size: 10px;
  }
`;
PaginationButton.displayName = 'PaginationButton';

export const DateRangeButton = styled.img`
  line-height: 17px;
  height: 23px;
  padding: 9px 5px;
  opacity: 0.3;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const ShowSmbFilter = styled.div`
  height: 25px;
  cursor: pointer;
  margin-right: 20px;
  min-width: 137px;
`;

export const CheckboxStandinImage = styled.img`
  margin-right: 5px;
  width: 13px;
  cursor: pointer;
`;

export const SmbFilterHolder = styled(FilterHolder)`
  min-width: 200px;
  flex: 1 1 ${(props) => `calc(${props.width} - 125px)`};
`;

export const BusinessToggleHolder = styled(FilterHolder)`
  width: calc(100% - 125px);
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  margin-top: 5px;
`;

// New styled components for redesigned filter layout

export const FilterBlock = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.lightGray21};
  padding-bottom: 20px;
  margin-bottom: 20px;

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 16px;
  }
`;

export const FilterBlockHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const FilterBlockTitle = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.45;
  color: ${colors.blue1};
`;

export const HideShowToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  cursor: pointer;

  span {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 11px;
    line-height: 1.45;
    color: ${colors.blue1};
    text-align: center;
  }

  img {
    width: 8px;
    height: 4px;
  }
`;

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  min-width: 0;
`;

export const FilterLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const FilterLineLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.45;
  color: ${colors.black4};
  min-width: 56px;
  width: 56px;
  flex-shrink: 0;
  text-align: left;
`;

export const FilterInput = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  width: 100%;

  > * {
    width: 100%;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  margin-top: 4px;
`;

export const CollapsibleSection = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

export const CollapsibleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  cursor: pointer;

  span {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 11px;
    line-height: 1.45;
    color: ${colors.darkGray1};
  }

  img {
    width: 8px;
    height: 4px;
  }
`;

export const IdentifierInput = styled.input`
  height: 25px;
  width: 100%;
  background-color: ${(props) => (props.disabled ? colors.lightGray7 : colors.baseBackground)};
  color: ${(props) => (props.disabled ? colors.inputGrey : colors.black4)};
  border: 1px solid ${colors.lightGray21};
  border-radius: 4px;
  padding: 0 8px;
  font-family: 'Roboto', sans-serif;
  font-weight: ${(props) => (props.disabled ? 500 : 400)};
  font-size: 11px;

  &:focus {
    outline: none;
    border-color: ${colors.blue1};
  }

  &::placeholder {
    color: ${colors.inputGrey};
    font-weight: 500;
  }
`;
